export function useFormat() {
  const CHART_TIMEZONE = 'Asia/Tehran'

  const size = (value) => {
    const abs = Math.abs(value)
    if (abs >= 1e9) return `${(value / 1e9).toFixed(2)}B`
    if (abs >= 1e6) return `${(value / 1e6).toFixed(2)}M`
    if (abs >= 1e3) return `${(value / 1e3).toFixed(1)}K`
    return value.toFixed(0)
  }

  const price = (value) =>
    value >= 1000
      ? value.toLocaleString('en-US', { maximumFractionDigits: 1 })
      : value.toPrecision(6)

  const percent = (value, digits = 1) =>
    value == null ? '—' : `${value > 0 ? '+' : ''}${value.toFixed(digits)}%`

  const time = (epochSeconds) =>
    new Date(epochSeconds * 1000).toLocaleString('en-GB', {
      timeZone: CHART_TIMEZONE,
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })

  const ago = (epochSeconds) => {
    const seconds = Math.max(0, Date.now() / 1000 - epochSeconds)
    if (seconds < 60) return `${Math.floor(seconds)}s ago`
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
    return `${Math.floor(seconds / 3600)}h ago`
  }

  return { size, price, percent, time, ago }
}
